import { Player } from "@lottiefiles/react-lottie-player";

export default function HowItWorks({ topTitle, steps }) {
  return (
    <section>
      <div className="container px-4 mx-auto flex flex-col justify-center mt-8 md:mt-12 mb-32">
        <div tabIndex={0}>
          <h2 className="main-top-title text-center mb-16 text-maingray">
            {topTitle}
          </h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-14">
          {steps.map(({ title, text, icon }) => (
            <div
              tabIndex={0}
              key={title}
              className="p-16 flex flex-col items-center text-center rounded-3xl shadow-lg transition ease-in-out hover:shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] "
            >
              <Player
                autoplay
                loop
                src={icon}
                style={{ height: "80px", width: "80px" }}
              />
              <h3 className="font-['Inter'] text-2xl font-bold text-orange-400 h-20 flex align-center mt-2">
                {title}
              </h3>
              <p className="main-text">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
